import { render, staticRenderFns } from "./ExportDB.vue?vue&type=template&id=c6f8a7ee&scoped=true&"
import script from "./ExportDB.vue?vue&type=script&lang=js&"
export * from "./ExportDB.vue?vue&type=script&lang=js&"
import style0 from "./ExportDB.vue?vue&type=style&index=0&id=c6f8a7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f8a7ee",
  null
  
)

export default component.exports